import { Row, Col, Input, Button } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

export const BusquedaSolicitudes = ({ 
  filtros, 
  onFiltroChange, 
  onActualizar 
}) => {
  const handleBusquedaChange = (e) => {
    onFiltroChange('busqueda', e.target.value);
  };

  return (
    <div className="busqueda-solicitudes">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={16} md={18}>
          <Input
            placeholder="Buscar por ID o descripción..."
            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
            value={filtros.busqueda}
            onChange={handleBusquedaChange}
            allowClear
            size="middle"
          />
        </Col>
        
        <Col xs={24} sm={8} md={6}>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={onActualizar}
            size="middle"
            className="gradient-button"
            style={{ width: '100%' }}
          >
            Actualizar
          </Button>
        </Col>
      </Row>
    </div>
  );
};